import api from '../../utils/api'
import apiSubmissionError from '../../utils/apiSubmissionError'

export const getAdminsApi = (params) => api.get('/admins', { params })
export const getAdminByIdApi = (id) => api.get(`/admins/${id}`)
export const deleteAdminByIdApi = (id) => api.delete(`/admins/${id}`)
export const createAdminApi = (data) => api.post(`/admins`, data).catch(apiSubmissionError)
export const updateAdminApi = (id, data) => api.put(`/admins/${id}`, data)
